import React from 'react';
import { ActionButton } from '@klp/design/Action';
import type { KostnadsSkjemaKalkyleRequest } from '@klp/prosjekt/services/types';
import { useFormikContext } from 'formik';
import { useKostnadsKalkyleContext } from '../context/KostnadsKalkyleProvider';
import { useTranslation } from 'react-i18next';
import { Block } from '@klp/design/Block';

export const KostnadsKalkyleFormSubmitButton = () => {
    const { t } = useTranslation();
    const { isSubmitting } = useFormikContext<KostnadsSkjemaKalkyleRequest>();
    const { isReadOnly } = useKostnadsKalkyleContext();

    return (
        <Block marginTop="bulky">
            <ActionButton
                actionType="submit"
                disabled={isSubmitting || isReadOnly}
            >
                {t('prosjekt.kostnadskalkyle.submit')}
            </ActionButton>
        </Block>
    );
};
